// Home's Ready for HRIS (lane B10 S14b; CR-052; BRD ch. 13 *Archive/reporting* HR Operations "Handoff", his HR
// Operations folded into the Coordinator by DC-228; G §5 "Offer Accepted -> Ready for HRIS -> HRIS Hired -> Filled ->
// Archived"): the hires B9's handoff has made Ready for HRIS and
// that the Coordinator has still to confirm, how many on each requisition, every row opening that requisition's Closure
// tab, where B9's HRIS card takes the confirmation. Requisitions and counts only; no candidate is named on Home.

import { Count, Row, RowName, Stack, Widget } from "@/mc";
import { ACTION_KIND_LABELS } from "@/mc/g3/labels";
import type { HomeWidgetView } from "./host";
import { DASH, hrisHandoffOf, seatsOf, type HrisHandoffData } from "./api";
import { EVENT_WORDS } from "@/views/b10/timeline/labels";
import { hsKey } from "@/views/b10/lib/hsKey";

/** The requisitions with a hire still to confirm, the most first; null when there is none. */
export function HrisHandoffBody({ data }: { data: HrisHandoffData }) {
  const rows = data.rows.filter((row) => row.ready > 0);
  if (rows.length === 0) return null;
  return (
    <Stack gap={0}>
      {rows.map((row) => (
        <Row key={row.requisition_id} cols={2} lead="75%" href={row.route || undefined} hs={hsKey("dash.handoff.req", row.requisition_id)}>
          <RowName name={row.title} sub={row.requisition_id} />
          <Count n={row.ready} label={ACTION_KIND_LABELS.candidates} />
        </Row>
      ))}
    </Stack>
  );
}

// D-25: a widget home.open composes is drawn even with nothing in it, its Card's empty slot holding B10's DASH, as
// ActiveRequisitions.tsx does.
/** Widget `hris_handoff` (B1's key for B9's handoff; its data is B10's binding, `reporting/dashboards.hris_handoff`). */
export const HrisHandoff: HomeWidgetView = ({ widgetKey, data }) => {
  const handoff = hrisHandoffOf(data);
  const none = handoff.rows.every((row) => row.ready === 0);
  return (
    <Widget
      id={widgetKey}
      kind="sections"
      roles={seatsOf(widgetKey)}
      title={EVENT_WORDS.readyForHris}
      count={handoff.ready}
      empty={none ? DASH : undefined}
    >
      {none ? null : <HrisHandoffBody data={handoff} />}
    </Widget>
  );
};
